// extracted by mini-css-extract-plugin
module.exports = {"SignupIFrame__body":"ps_a","autofill":"ps_b","SignupIFrame__pageContent":"ps_c"};